import React from 'react';
// import Helmet from 'react-helmet';
import { Opening } from './components/Opening/index';

function App() {
  return (
    <div>
      {/* <Helmet title={'小馆开张啦'} /> */}
      <Opening />
    </div>
  );
}

export default App;
